import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';

const Contactanos = () => {
  return (
    <section id="contactanos" style={{ padding: '5rem 0', backgroundColor: 'var(--bg-dark, #121212)', color: 'var(--text-light, #ffffff)' }}>
      <Container>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 className="cormorant-garamond menu-main-title" style={{ marginBottom: '1rem', color: 'var(--accent-gold, #d4af37)' }}>
            Contáctanos
          </h2>
          <p className="menu-subtitle" style={{ fontSize: '1.2rem', maxWidth: '800px', margin: '0 auto', color: 'var(--text-secondary, #b3b3b3)', lineHeight: '1.6' }}>
            ¿Te gustaría cotizar catering para eventos o almuerzos ejecutivos? Tenemos cobertura sin costo de delivery a todo San Isidro. Por favor contáctanos a nuestro número de WhatsApp <a href="https://wa.me/51948156106" style={{ color: 'var(--accent-gold, #d4af37)', textDecoration: 'none', fontWeight: 'bold' }}>+51 948156106</a> o a través de nuestro correo electrónico.
          </p>
        </div>

        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <Form action="https://formsubmit.co/igdemsar@gmail.com" method="POST" style={{ backgroundColor: 'rgba(255, 255, 255, 0.05)', padding: '2.5rem', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.5)', border: '1px solid rgba(212, 175, 55, 0.1)' }}>
              <Form.Group className="mb-4" controlId="formName">
                <Form.Label style={{ color: 'var(--accent-gold, #d4af37)', fontFamily: 'Cormorant Garamond, serif', fontSize: '1.3rem' }}>Nombre</Form.Label>
                <Form.Control type="text" name="name" placeholder="Tu nombre" required style={{ backgroundColor: 'rgba(0,0,0,0.2)', color: '#fff', border: '1px solid rgba(255, 255, 255, 0.2)', borderRadius: '8px', padding: '12px' }} />
              </Form.Group>

              <Form.Group className="mb-4" controlId="formEmail">
                <Form.Label style={{ color: 'var(--accent-gold, #d4af37)', fontFamily: 'Cormorant Garamond, serif', fontSize: '1.3rem' }}>Correo Electrónico</Form.Label>
                <Form.Control type="email" name="email" placeholder="Tu correo" required style={{ backgroundColor: 'rgba(0,0,0,0.2)', color: '#fff', border: '1px solid rgba(255, 255, 255, 0.2)', borderRadius: '8px', padding: '12px' }} />
              </Form.Group>

              <Form.Group className="mb-4" controlId="formMessage">
                <Form.Label style={{ color: 'var(--accent-gold, #d4af37)', fontFamily: 'Cormorant Garamond, serif', fontSize: '1.3rem' }}>Mensaje</Form.Label>
                <Form.Control as="textarea" name="message" rows={5} placeholder="Escribe tu mensaje aquí..." required style={{ backgroundColor: 'rgba(0,0,0,0.2)', color: '#fff', border: '1px solid rgba(255, 255, 255, 0.2)', borderRadius: '8px', padding: '12px' }} />
              </Form.Group>

              <div className="text-center mt-5">
                <Button variant="primary" type="submit" style={{
                  backgroundColor: 'var(--accent-gold, #d4af37)',
                  borderColor: 'var(--accent-gold, #d4af37)',
                  color: '#000',
                  fontWeight: 'bold',
                  padding: '12px 35px',
                  borderRadius: '30px',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  fontSize: '1rem',
                  transition: 'all 0.3s ease'
                }}>
                  Enviar Mensaje
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contactanos;
